export const BASE_URL ='https://fesprisadmintest-gnaaascaf7c8dwfu.eastus-01.azurewebsites.net/app/v1'